module.exports = __webpack_public_path__ + "img/login1.f352bd21.png";